import { render } from "./profile-completed.vue?vue&type=template&id=112e7222&scoped=true"
import script from "./profile-completed.vue?vue&type=script&lang=js"
export * from "./profile-completed.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=112e7222&scoped=true&lang=css"
import "./profile-completed.vue?vue&type=style&index=1&id=112e7222&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112e7222"]])

export default __exports__